import { Radio, type RadioProps } from '@chakra-ui/react'
import { SizeType } from '@/types'
import React from 'react'


interface Props extends RadioProps {
  size?: SizeType,
}

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Radio ref={ref} {...props} />
  )
})

export {
  Component as Radio,
  type Props as RadioProps,
}